const VueSelect = defineAsyncComponent(() => import('vue-select'))

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('v-select', VueSelect)
})